package com.schoolconnect.app.util

object AppInfo {
    val versionName: String = "1.0.0"
    const val isDebug: Boolean = false
}
